import { Link } from 'react-router-dom';

const footerLinks = [
  { label: '恋爱漫画', path: '/category/romance' },
  { label: '奇幻漫画', path: '/category/fantasy' },
  { label: '动作漫画', path: '/category/action' },
  { label: '悬疑漫画', path: '/category/suspense' },
  { label: '搞笑漫画', path: '/category/comedy' },
  { label: '治愈漫画', path: '/category/healing' },
];

const aboutLinks = [
  { label: '关于我们', path: '/about' },
  { label: '联系我们', path: '/about' },
  { label: '用户协议', path: '/about' },
  { label: '隐私政策', path: '/about' },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="font-heading text-2xl text-white mb-4 whitespace-nowrap">
              基德漫画
            </h3>
            <p className="text-foreground-400 text-sm leading-relaxed mb-6">
              基德漫画网提供好看韩漫漫画免费漫画，支持韩漫免费漫画在线观看下拉式阅读体验。每日更新，资源丰富，是韩漫爱好者的最佳选择。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5 whitespace-nowrap">
              漫画分类
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5 whitespace-nowrap">
              关于本站
            </h4>
            <ul className="flex flex-col gap-3">
              {aboutLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5 whitespace-nowrap">
              联系方式
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-foreground-400 text-sm"></i>
                </div>
                <span className="text-foreground-400 text-sm">hello@bjgjfh.com</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-customer-service-line text-foreground-400 text-sm"></i>
                </div>
                <span className="text-foreground-400 text-sm">在线客服（工作日 9:00-18:00）</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 基德漫画网. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-foreground-500 hover:text-white text-xs transition-colors cursor-pointer">
              关于我们
            </Link>
            <Link to="/about" className="text-foreground-500 hover:text-white text-xs transition-colors cursor-pointer">
              隐私政策
            </Link>
            <Link to="/about" className="text-foreground-500 hover:text-white text-xs transition-colors cursor-pointer">
              服务条款
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}